import { GenericErrorScreenComponent } from 'components/messages/GenericErrorScreen';
import { LoadingScreenComponent } from 'components/LoadingScreen';
import { useUserSession } from 'common/stores/UserSessionStore';
import { matchProject } from 'common/helpers/GameHelper';
import HttpService from 'common/services/HttpService';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
	USER_ACCOUNT_SESSION_NAMESPACE,
	LEAP_AUTH_SESSION_NAMESPACE
} from 'assets/configurations/envConfigs';


export function LeapAuthComponent({ children }) {
    const { session = {}, updateSession, getLeapAccount } = useUserSession();
    const [error, setError] = useState(false);
    const { projectId } = useParams() || {};
    

    useEffect(() => {
        setGameUser();
    }, []);

    function getClientCredentials() {
        return session[LEAP_AUTH_SESSION_NAMESPACE];
    };

    function setClientCredentials(clientCredentials) {
        updateSession({...session, [LEAP_AUTH_SESSION_NAMESPACE]: clientCredentials });
        fetchMe();
    };

    function removeClientCredentials() {
        return updateSession({
            ...session,
            [USER_ACCOUNT_SESSION_NAMESPACE]: null,
            [LEAP_AUTH_SESSION_NAMESPACE]: null
        });
    };

    function destroySession() {
        return updateSession({});
    };

    async function fetchMe() {
        const user = getLeapAccount();

        if(user && user.status !== 401) {
            return user;
        };

        try {
            const { body } = await HttpService.fetchMe();

            if(body.status === 401) {
                throw new Error(body.message);
            };

            updateSession({ ...session, [USER_ACCOUNT_SESSION_NAMESPACE]: body });

            return body;
        } catch (error) {
            console.log(error);

            setError(true);
            return null;
        };
    };

    async function setGameUser() {
        const { gameId } = matchProject(projectId);
        
        try {
            const user = await fetchMe();

            if(!user) {
                return;
            };

            await HttpService.setGameUser({ gameId, userId: user?.uid });
        } catch (error) {
            console.log(error);
        };
    }

    HttpService.initOAuthHandler = {
        removeClientCredentials,
        setClientCredentials,
        getClientCredentials,
        destroySession
    };

    return error ? (
        <GenericErrorScreenComponent withHeaderBar={false} />
    ) : getLeapAccount() ? children : (
        <LoadingScreenComponent />
    );
};